import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import { deleteDietaryPreference } from "../actions";

export function CreateDietaryPreference() {
  return (
    <Link to={"/admin/dietary-preferences/create"}>
      <Button className="mt-4">
        Create Dietary Preference
        <Icon icon={PlusIcon} label="Create Dietary Preference" className="ml-1" />
      </Button>
    </Link>
  );
}


export function UpdateDietaryPreference({ id }: { id: string }) {
  return (
    <Link to={`/admin/dietary-preferences/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteDietaryPreference({ id }: { id: string }) {
  const navigate = useNavigate();

  const deleteDietaryPreferenceWithId = deleteDietaryPreference.bind(null, id);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this dietary preference?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteDietaryPreferenceWithId, {
    success: false,
  });
  useEffect(() => {
    if (state.success) {
      navigate("/admin/dietary-preferences?reload=true", { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}



